import _ from "lodash";
import { constants } from '../../Constants/constants'

export const getPayloadWithHyperLink = (payload) => {

  const result = _.cloneDeep(payload);
  for(const item of result) {
    item.templateCodeHyperLink = `/${constants.PATH.SHOP.QUEUE.QUEUE_TEMPLATE}/${item.templateId}/0`
  }

  return result;

}